import React, { Component } from 'react'
import { Menu } from 'antd'
import classnames from 'classnames'
import './index.less'
import ranges from './ranges'

class DatePicker extends Component {
  static defaultProps = {
    format: 'YYYY-MM-DD',
    value: []
  }

  onChange(m) {
    this.props.onChange([m.value[0].format(this.props.format), m.value[1].format(this.props.format)])
  }

  isSame(m) {
    const [start, end] = this.props.value
    if (!start || !end) {
      return false
    }
    return m.value[0].isSame(start, 'day') && m.value[1].isSame(end, 'day')
  }

  render() {
    return (
      <Menu>
        {ranges.filter(m => m.show).map(m => (
          <Menu.Item onClick={this.onChange.bind(this, m)}>
            <span className={classnames('mini-item', { active: this.isSame(m) })}>{m.name}</span>
          </Menu.Item>))}
      </Menu>
    )
  }
}

export default DatePicker
